export type Perm = { byte: number; bit: number }

export function perm_gen_auto(): () => Perm {
    let bit = 0
    let byte = 0
    return () => {
        let perm: Perm = { bit: bit++, byte }
        if (bit > 7) {
            bit = 0
            byte++
        }
        return perm
    }
}

const auto = perm_gen_auto()

export const PERMS_SIZE = 32

export class Perms {
    static MASTER: Perm = auto()

    static V_USER: Perm = auto()
    static A_USER: Perm = auto()
    static C_USER: Perm = auto()
    static D_USER: Perm = auto()

    static V_COMPANY: Perm = auto()
    static A_COMPANY: Perm = auto()
    static C_COMPANY: Perm = auto()
    static D_COMPANY: Perm = auto()

    static V_HELMET: Perm = auto()
    static A_HELMET: Perm = auto()
    static C_HELMET: Perm = auto()
    static D_HELMET: Perm = auto()

    static V_HELMET_CARGO: Perm = auto()
    static A_HELMET_CARGO: Perm = auto()
    static C_HELMET_CARGO: Perm = auto()
    static D_HELMET_CARGO: Perm = auto()

    static V_COOPERATION: Perm = auto()
    static A_COOPERATION: Perm = auto()
    static C_COOPERATION: Perm = auto()
    static D_COOPERATION: Perm = auto()

    #perms: number[]
    constructor(perms: number[]) {
        perms = perms.map(p => Math.min(p, 255))

        for (let i = PERMS_SIZE - perms.length; i > 0; i--) {
            perms.push(0)
        }

        perms = perms.slice(0, PERMS_SIZE)
        this.#perms = perms
    }

    any(): boolean {
        for (let p of this.#perms) {
            if (p != 0) return true
        }
        return false
    }

    any_of(...perms: Perm[]): boolean {
        for (let p of perms) {
            if (this.get(p)) return true
        }

        return false
    }

    check(...perms: Perm[]): boolean {
        if (this.get(Perms.MASTER)) return true

        for (let p of perms) {
            if (!this.get(p)) return false
        }

        return true
    }

    get({ byte, bit }: Perm): boolean {
        if (byte >= this.#perms.length) {
            throw new Error('invalid byte')
        }
        let f = 1 << bit
        let n = this.#perms[byte]!
        return (n & f) == f
    }

    set({ byte, bit }: Perm, value: boolean) {
        if (byte >= this.#perms.length) {
            throw new Error('invalid byte')
        }
        let f = 1 << bit
        if (value) {
            this.#perms[byte]! |= f
        } else {
            this.#perms[byte]! &= ~f
        }
    }

    toggle(perm: Perm) {
        this.set(perm, !this.get(perm))
    }

    get perms(): number[] {
        return this.#perms
    }
}
// @ts-ignore
delete globalThis.auto

export type PermDpy = {
    perm: Perm
    name: string
}
export type PermDpyGroup = {
    name: string
    perms: PermDpy[]
}

export const PERMS_DISPLAY: PermDpyGroup[] = [
    {
        name: 'users',
        perms: [
            {
                perm: Perms.V_USER,
                name: 'view',
            },
            {
                perm: Perms.A_USER,
                name: 'add',
            },
            {
                perm: Perms.C_USER,
                name: 'change',
            },
            {
                perm: Perms.D_USER,
                name: 'delete',
            },
        ],
    },
]
